import instance from 'src/common/http/axiosInstance';
import { mapToData } from 'src/common/http/mapToData';
import { mapToErrors } from 'src/common/http/mapToErrors';

import { TierApprovalActionDTO, TierApprovalDTO } from './dtos';

export const tierApprovalsService = {
  approve: async (projectId: string, body: TierApprovalActionDTO): Promise<TierApprovalDTO> =>
    instance
      .post<TierApprovalDTO>(`projects/${projectId}/tier-approvals/approve`, body)
      .then(mapToData)
      .catch(mapToErrors),
};
